import React from 'react'
import ReactDOM from 'react-dom'
import firebase from 'firebase/app'
import { Provider } from 'react-redux'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles'

import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/firebase-auth'

import App from './App'
import Admin from './containers/Admin'
import Login from './containers/Login'
import ScrollTop from './components/ScrollTop'

import store from './store'
import { FIREBASE_CONFIG } from './constant'
import * as serviceWorker from './serviceWorker'

import theme from './theme'


firebase.initializeApp(FIREBASE_CONFIG)

firebase.firestore().enablePersistence().catch(console.error)

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ScrollTop>
        <MuiThemeProvider theme={theme}>
          <App>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/admin" component={Admin} />
            </Switch>
          </App>
        </MuiThemeProvider>
      </ScrollTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
